module.exports = __webpack_public_path__ + "static/media/sort-descending.bd9d9142.svg";